const year = new Date().getFullYear();
export default [
  {
    path: '/pledge/index',
    name: 'index',
    component: () => import('@/views/pledge'),
    meta: {
      title: `${year}高考誓师大会-高考直通车`
    }
  },
  {
    path: '/pledge/pledgepersonal',
    name: 'pledgepersonal',
    component: () => import('@/views/pledge/pledgepersonal'),
    meta: {
      title: `${year}高考誓师大会-高考直通车`
    }
  },
  {
    path: '/pledge/pledgelist',
    name: 'pledgelist',
    component: () => import('@/views/pledge/pledgelist'),
    meta: {
      title: `${year}高考誓师大会-高考直通车`
    }
  },
  {
    path: '/pledge/pledgeform',
    name: 'pledgeform',
    component: () => import('@/views/pledge/pledgeform'),
    meta: {
      title: `${year}高考誓师大会-高考直通车`
    }
  },
  {
    path: '/pledge/pledgeupload',
    name: 'pledgeupload',
    component: () => import('@/views/pledge/pledgeupload'),
    meta: {
      title: `${year}高考誓师大会-高考直通车`
    }
  },
  {
    path: '/pledge/blessing',
    name: 'blessing',
    component: () => import('@/views/pledge/blessing'),
    meta: {
      title: '送出你的寄语，为大家加油助威！'
    }
  },
  {
    path: '/pledge/myblessing',
    name: 'myblessing',
    component: () => import('@/views/pledge/myblessing'),
    meta: {
      title: '送出你的寄语，为大家加油助威！'
    }
},
  {
    path: '/pledge/mypledge',
    name: 'mypledge',
    component: () => import('@/views/pledge/mypledge'),
    meta: {
      title: '送出你的寄语，为大家加油助威！'
    }
  },{
    path: '/pledge/pledgeinfo',
    name: 'pledgeinfo',
    component: () => import('@/views/pledge/pledgeinfo'),
    meta: {
      title: `${year}高考誓师大会-高考直通车`
    }
  },
  {
    path: '/pledge/blessing',
    name: 'blessing',
    component: () => import('@/views/pledge/blessing'),
    meta: {
      title: '送出你的学霸寄语，为参加2026高考的学弟学妹们加油助威！'
    }
  },
  {
    path: '/pledge/myblessing',
    name: 'myblessing',
    component: () => import('@/views/pledge/myblessing'),
    meta: {
      title: '送出你的学霸寄语，为参加2026高考的学弟学妹们加油助威！'
    }
  },
  {
    path: '/pledge/lotteryRecord',
    name: 'lotteryRecord',
    component: () => import('@/views/pledge/lotteryRecord'),
    meta: {
      title: '写下你的誓词，赢超级大利！'
    }
  },
  {
    path: '/pledge/lottery',
    name: 'lottery',
    component: () => import('@/views/pledge/lottery'),
    meta: {
      title: '写下你的誓词，赢超级大利！'
    }
  },
  {
    path: '/pledge/scene',
    name: 'scene',
    component: () => import('@/views/pledge/scene'),
    meta: {
      title: `${year}高考誓师大会-高考直通车`
    }
  },
  {
    path: '/pledge/pledgeformscene',
    name: 'pledgeformscene',
    component: () => import('@/views/pledge/pledgeformscene'),
    meta: {
      title: `${year}高考誓师大会-高考直通车`
    }
  }
]
